import React from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";
import PackageCard from "@/components/site/PackageCard";
import IsIsNotGrid from "@/components/site/IsIsNotGrid";
import CtaBanner from "@/components/site/CtaBanner";
import { PACKAGES } from "@/components/site/solutionsPackages";

export default function Solutions() {
  return (
    <div>
      <SEO
        title="Solutions for CLIA & CAP Documentation | LabComplyx"
        description="Five defined starting points for CLIA and CAP labs: Lab Health Score, Workflow Assessment, Governed AI Pilot, Readiness Sprint, and Fractional Support."
        keywords="CLIA lab documentation workflows, CAP inspection readiness, CAPA deviation control small labs, governed workflows, small clinical lab compliance"
        canonical="https://labcomplyx.com/solutions"
        ogUrl="https://labcomplyx.com/solutions"
        breadcrumbs={[
          { name: "Home", url: "https://labcomplyx.com/" },
          { name: "Solutions", url: "https://labcomplyx.com/Solutions" },
        ]}
      />
      <PageHero
        title="Documentation workflows for every stage of compliance readiness"
        sub="Whether you're preparing for an inspection, recovering from a finding, or building a system for the first time — LabComplyx has a defined starting point."
      />
      <section className="py-14 bg-background">
        <div className="max-w-4xl mx-auto px-6 space-y-5">
          {PACKAGES.map((pkg) => (
            <PackageCard key={pkg.title} pkg={pkg} />
          ))}
        </div>
      </section>
      <IsIsNotGrid />
      <CtaBanner title="Start with the free Lab Health Score" healthLabel="Get My Health Score →" />
    </div>
  );
}